import { render, staticRenderFns } from "./mv-wd-canvas-list.vue?vue&type=template&id=588ab5c3"
import script from "./mv-wd-canvas-list.vue?vue&type=script&lang=js"
export * from "./mv-wd-canvas-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports